module.exports = __webpack_public_path__ + "static/img/zx.c21cee6.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/project/vipnotifyProject/images/zx.jpg
// module id = /msI
// module chunks = 7